const BUSINESS_ID = 'business_id';

export default {
  getBusinessId() {
    return window.localStorage.getItem(BUSINESS_ID);
  },

  setBusinessId(business_id) {
    window.localStorage.setItem(BUSINESS_ID, business_id);
  },

  destroyBusinessId() {
    window.localStorage.removeItem(BUSINESS_ID);
  },
};



// WEBPACK FOOTER //
// ./src/services/business.service.js